/**
 * Normalize any API/exception error into a user-friendly string.
 * Handles FastAPI/Pydantic v2 validation error arrays (which would otherwise crash React).
 */
export function normalizeApiError(err, fallback = "Произошла ошибка") {
  if (!err) return fallback;
  // Direct string
  if (typeof err === "string") return err;
  // axios error object — preferred path
  const detail = err?.response?.data?.detail;
  if (detail !== undefined && detail !== null) {
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      // Pydantic v2 validation errors: [{type, loc, msg, input, url}, ...]
      return detail
        .map(d => {
          if (typeof d === "string") return d;
          const loc = Array.isArray(d?.loc) ? d.loc.filter(x => x !== "body").join(".") : "";
          const msg = d?.msg || d?.message || JSON.stringify(d);
          return loc ? `${loc}: ${msg}` : msg;
        })
        .join("; ");
    }
    if (typeof detail === "object") {
      return detail.msg || detail.message || JSON.stringify(detail);
    }
    return String(detail);
  }
  // userMessage attached by ncalayer.js
  if (err.userMessage) return err.userMessage;
  if (err.message) return err.message;
  return fallback;
}
